export const AUTH_LOGIN_REQUESTED = 'AUTH_LOGIN_REQUESTED';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_USER_REQUESTED = 'AUTH_USER_REQUESTED';

export const DIRECTORY_REQUESTED = 'DIRECTORY_REQUESTED';
export const DIRECTORY_SUCCESS = 'DIRECTORY_SUCCESS';
export const DIRECTORY_FAILURE = 'DIRECTORY_FAILURE';

export const HISTORY_REQUESTED = 'HISTORY_REQUESTED';
export const HISTORY_SUCCESS = 'HISTORY_SUCCESS';
export const HISTORY_FAILURE = 'HISTORY_FAILURE';

export const PROPERTY_VALUE_UPDATE = 'PROPERTY_VALUE_UPDATE';
export const PROPERTY_VALUE_REQUEST = 'PROPERTY_VALUE_REQUEST';

export const WS_CONNECTED = 'WS_CONNECTED';
export const WS_CONNECTING = 'WS_CONNECTING';
export const WS_DISCONNECTED = 'WS_DISCONNECTED';

export const WS_RECONNECTION_INTERVAL = 2000;

export const CONNECTION_STATUS_CONNECTED = 'connected';
export const CONNECTION_STATUS_CONNECTING = 'connecting';
export const CONNECTION_STATUS_DISCONNECTED = 'disconnected';
